import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("option", { value: "GHV" }, "GHV", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("option", { value: "SANTANDREA" }, "SANTANDREA", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("option", { value: "CORPORATE" }, "CORPORATE", -1);
const _hoisted_4 = [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localValue) = $event)),
            onChange: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, _hoisted_4, 544), [
            [_vModelSelect, _ctx.localValue]
        ])
    ]));
}
